export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./baas-frame.vue?vue&type=template&id=6ae39123"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/baas/baas-frame.vue?vue&type=template&id=6ae39123
// module id = kpKN
// module chunks = 0